export default {
  'menu.welcome': 'Selamat Datang',
  'menu.more-blocks': 'Blocks Lainnya',
  'menu.home': 'Halaman Awal',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Halaman',
  'menu.login': 'Masuk',
  'menu.register': 'Pendaftaran',
  'menu.register-result': 'Hasil Pendaftaran',
  'menu.dashboard': 'Dasbor',
  'menu.dashboard.analysis': 'Analisis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Form Dasar',
  'menu.form.step-form': 'Form Bertahap',
  'menu.form.step-form.info': 'Form Bertahap(menulis informasi yang dibagikan)',
  'menu.form.step-form.confirm': 'Form Bertahap(konfirmasi informasi yang dibagikan)',
  'menu.form.step-form.result': 'Form Bertahap(selesai)',
  'menu.form.advanced-form': 'Form Lanjutan',
  'menu.list': 'Daftar',
  'menu.list.table-list': 'Tabel Pencarian',
  'menu.list.basic-list': 'Daftar Dasar',
  'menu.list.card-list': 'Daftar Kartu',
  'menu.list.search-list': 'Daftar Pencarian',
  'menu.list.search-list.articles': 'Daftar Pencarian(artikel)',
  'menu.list.search-list.projects': 'Daftar Pencarian(projek)',
  'menu.list.search-list.applications': 'Daftar Pencarian(aplikasi)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil Dasar',
  'menu.profile.advanced': 'Profile Lanjutan',
  'menu.result': 'Hasil',
  'menu.result.success': 'Sukses',
  'menu.result.fail': 'Gagal',
  'menu.exception': 'Pengecualian',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Jalankan',
  'menu.account': 'Akun',
  'menu.account.center': 'Detail Akun',
  'menu.account.settings': 'Pengaturan Akun',
  'menu.account.trigger': 'Mengaktivasi Error',
  'menu.account.logout': 'Keluar',
  'menu.editor': 'Penyusun Grafis',
  'menu.editor.flow': 'Penyusun Alur',
  'menu.editor.mind': 'Penyusun Mind',
  'menu.editor.koni': 'Penyusun Koni',
  'menu.user-management': 'Pengguna',
  'menu.tag-management': 'Tag',
  'menu.canned-response': 'Kaleng',
  'menu.chatrooms': 'Ruang Obrolan',
  'menu.email': 'Email',
  'menu.core': 'Fitur Utama',
  'menu.files': 'File',
  'menu.favouritesHub': 'Perkara',
  'menu.library': 'Perpustakaan Prompt',
  'menu.chat': 'Obrolan',
  'menu.search': 'Pencarian',
  'menu.specialised': 'Khusus',
  'menu.app': 'Analisis',
  'menu.playbook': 'Buku Pedoman',
  'menu.template': 'Output Khusus',
  'menu.quote': 'Kutipan',
  'menu.review': 'Ulasan',
  'menu.sideBySide': 'Sisi Demi Sisi',
  'menu.grading': 'Penilaian',
  'menu.setting': 'Pengaturan',
  'menu.diagnostics': 'Diagnosis',
  'menu.context': 'Konteks',
  'menu.management': 'Kelola',
  'menu.conversation': 'Percakapan',
  'menu.broadcast': 'Siaran',
  'menu.dictionary': 'Kamus',
  'menu.question': 'Pertanyaan',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': 'Alur Baru',
  'menu.form.update-flow': 'Modify Alur',
  'menu.list.flow-list': 'Daftar Alur',
  'menu.entity': 'Entitas',
  'menu.flow': 'Alur',
  'menu.divider': 'Pemisah',
  'menu.filesNew': 'File (Baru)',
  'menu.filesRefactored': 'File (Diperbarui)',
  'menu.translation': 'Terjemahan',
  'menu.comparison': 'Perbandingan',
  'menu.scribe': 'Rekaman',
  'menu.organisation': 'Organisasi',
  'menu.superAdminOrganisation': 'Organisasi Super Admin',
  'menu.section.vault': 'Vault',
  'menu.section.chatAndCompose': 'Obrolan & Penyusunan',
  'menu.section.specialised': 'Khusus',
  'menu.section.system': 'Sistem',
};
